import { createAuthClient } from './auth/createAuthClient'
import { topAuthOptionsSchema } from './auth/types/TopAuthOptions.schema'

export const app = {
  createAuthClient: (options: unknown) => {
    return createAuthClient(topAuthOptionsSchema.parse(options))
  },
}
